module.exports = __webpack_public_path__ + "assets/avatar-neverdividebyzero.64932fb7.svg";